'use client';
import { Typography } from '@curology/ui-components-web/react';
import { Accordion } from '@curology/ui-components-web/react/Accordion';
import { AccordionContent } from '@curology/ui-components-web/react/Accordion/AccordionContent';
import { AccordionSummary } from '@curology/ui-components-web/react/Accordion/AccordionSummary';
import React, { useState } from 'react';

import {
  getFormattedPrice,
  getTotal,
  getTotalWithoutDiscount,
} from '@/components/flow/expressCurologySignUpSkin/utils';
import { AnalyticsEvent, FlowTypes, trackEvent } from '@/utils/analytics';

import { PriceSummary } from './priceSummary';
import { type ExpressCurologySignUpSkinPdpSourceConfigType } from '../types';

export const PriceSummaryAccordion = ({
  bundleConfig,
  giftWithPurchaseImageUrl,
  selectedAddOnProductItemIds,
}: {
  bundleConfig: ExpressCurologySignUpSkinPdpSourceConfigType;
  giftWithPurchaseImageUrl?: string;
  selectedAddOnProductItemIds: number[];
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const { offerId } = bundleConfig;

  const total = getTotal(bundleConfig, selectedAddOnProductItemIds);

  const totalWithoutDiscount = getTotalWithoutDiscount(
    bundleConfig,
    selectedAddOnProductItemIds,
  );

  return (
    <Accordion className="cur-bg-surface-neutral">
      <AccordionSummary
        className="cur-p-4"
        onClick={() => {
          const newIsOpen = !isOpen;

          setIsOpen(newIsOpen);

          trackEvent(
            newIsOpen
              ? AnalyticsEvent.CHECKOUT_PRICE_DROPDOWN_OPENED
              : AnalyticsEvent.CHECKOUT_PRICE_DROPDOWN_CLOSED,
            {
              flow: FlowTypes.PDP_CHECKOUT,
              offerId,
            },
          );
        }}
      >
        <div className="cur-flex cur-items-center cur-justify-between">
          <Typography weight="bold">Today&apos;s total</Typography>
          <div className="cur-flex cur-items-center">
            <Typography className="cur-mr-2" weight="bold">
              {getFormattedPrice(total)}
            </Typography>
            <Typography className="cur-line-through cur-text-disabled">
              {getFormattedPrice(totalWithoutDiscount)}
            </Typography>
          </div>
        </div>
      </AccordionSummary>
      <AccordionContent>
        <PriceSummary
          bundleConfig={bundleConfig}
          giftWithPurchaseImageUrl={giftWithPurchaseImageUrl}
          selectedAddOnProductItemIds={selectedAddOnProductItemIds}
        />
      </AccordionContent>
    </Accordion>
  );
};
